import { Fragment } from 'react'
import Translate from '../../i18n/Translate'

const InfoGeneral = ({ info }) => {
    const formatSection = (section) => {
        switch (section) {
            case 'languages':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.languages" />
                        </h3>
                        <p className="copy">{info[section].join(' | ')}</p>
                    </>
                )
            case 'food':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.food" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'includes':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.includes" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'not_includes':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.not_includes" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'departures':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.departures" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'aereo':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.aereo" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'info':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.info" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'important':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.important" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            case 'difficulty':
                return (
                    <>
                        <h3 className="subtitle">
                            <Translate langkey="itinerary_detail.info.difficulty" />
                        </h3>
                        <p className="copy">{info[section]}</p>
                    </>
                )
            default:
                break
        }
    }

    return (
        <section className="incoming-itinerary-detail__info">
            <h2 className="title">
                <Translate langkey="itinerary_detail.info.title" />
            </h2>

            {Object.keys(info).map((section) => (
                <Fragment key={section}>{formatSection(section)}</Fragment>
            ))}
        </section>
    )
}

export default InfoGeneral
